import React, {useEffect, useState} from "react";
import {Col, Grid, Row} from "xps-react";
import {Button, Dropdown, DropdownItem, Name, RadioGroup} from "../../components";
import {ProfileSettingsContent} from "../ProfileSettings/ProfileSettings";
import {
    NewClientProfileValidationContainer, selectIsSaveButtonClicked, selectNewClientFormValidation,
    selectProfileRequestForm,
    selectProfileRequestFormDataForSecondary,
    setIsSaveButtonClicked, setIsValidForm,
    setNewClientFormValidation, setNewClientFormValidationForSecondary,
    setProfileRequestForm,
    setProfileRequestFormDataForSecondary
} from "../NewClientProfile/NewClientProfileSlice";
import {validateInputRemovingSpaces} from "../../utils/stringUtils";
import {NewClientPrimaryContact} from "../NewClientProfile/NewClientPrimaryContact";
import NewClientFinancialModel from "../NewClientProfile/NewClientFinancialModel";
import {EffectiveFees} from "../NewClientProfile/EffectiveFees";
import EffectiveTaxRates, {taxRateWithDefaults} from "../NewClientProfile/EffectiveTaxRates";
import {ReferenceDataType} from "../../models/referenceData/ReferenceDataType";
import {referenceDataClient} from "../../core/ReferenceDataClient";
import {defaultReferenceData} from "../NewClientProfile/NewClientProfile";
import {useAppDispatch, useAppSelector} from "src/store/hooks";
import {getClientRelationshipGroupInfoState} from "./ClientRelationshipGroupInfoSlice";
import {ClientRelationshipGroup, ClientRelationshipGroupParty} from "../models/ClientRelationshipGroupHierarchy";
import {useHistory, useParams} from "react-router-dom";
import {RouteWithProfileType} from "../../routes/types";
import {calculateAgeFromBirthdate, calculateBirthdateFromAge} from "../../utils/dateUtils";
import moment from "moment";
import {checkGender} from "../models/MemberType";
import {
    getDisplayPartnerRelationshipTypesForClientRelationshipGroup
} from "../FamilyTree/RelationshipTypeUtil";
import {clientManagementApiClient} from "../ClientManagementApiClient";
import {ProfileRequest, validateProfileResponseContainer} from "../models/ProfileResponse";

const getMiddleInitial = (middleName: string | null) => middleName?.trim().charAt(0) || "";

const ClientRelationshipGroupInfo = () => {
    const [referenceData, updateReferenceData] = useState(defaultReferenceData);
    const [selectedPrimaryContact, setSelectedPrimaryContact] = useState<string | undefined>(undefined);
    const [selectedRelationshipType, setSelectedRelationshipType] = useState<string | null>(null);
    const profileRequestFormForPrimary = useAppSelector(selectProfileRequestForm);
    const profileRequestFormDataForSecondary = useAppSelector(selectProfileRequestFormDataForSecondary);
    const clientRelationshipGroupInfoState = useAppSelector(getClientRelationshipGroupInfoState);
    const {newClientProfileForm} = useAppSelector(selectNewClientFormValidation);
    const isSaveButtonClicked = useAppSelector(selectIsSaveButtonClicked)
    const dispatch = useAppDispatch();
    const {crgid} = useParams<RouteWithProfileType>();
    const history = useHistory();
    const clientRelationshipGroupInformation : ClientRelationshipGroup = clientRelationshipGroupInfoState.clientRelationshipGroups.find(ele => ele.crgid === crgid)!;
    const hasSecondaryClientRelationshipGroupMember = clientRelationshipGroupInformation.parties.length > 1;
    const primaryContactValues : string [] = [clientRelationshipGroupInformation.parties[0].wmFullLegalEntityName!]
    if (clientRelationshipGroupInformation.parties[1]) {
        primaryContactValues.push(clientRelationshipGroupInformation.parties[1].wmFullLegalEntityName!)
    }
    useEffect(() => {
        const fetchReferenceData = async () => {
            try {
                const data: ReferenceDataType = await referenceDataClient.getReferenceData();
                updateReferenceData(data);
                let primaryContact = profileRequestFormForPrimary.primaryContact;
                let primaryContactForSecondary = profileRequestFormDataForSecondary!.primaryContact;


                if(clientRelationshipGroupInfoState.clientRelationshipGroups.length>0)
                {

                    if(clientRelationshipGroupInformation.parties.length > 0 )
                    {
                        let ClientRelationshipGroupPartyPrimaryMember:ClientRelationshipGroupParty = clientRelationshipGroupInformation.parties[0];
                        primaryContact = {
                                            ...primaryContact,
                                            firstName: ClientRelationshipGroupPartyPrimaryMember.personFirstNameProperCased || "",
                                            lastName: ClientRelationshipGroupPartyPrimaryMember.personLastNameProperCased || "",
                                            birthdate: ClientRelationshipGroupPartyPrimaryMember.birthDate ? moment(ClientRelationshipGroupPartyPrimaryMember.birthDate).format('YYYY-MM-DD') : calculateBirthdateFromAge(0),
                                            gender: checkGender(ClientRelationshipGroupPartyPrimaryMember.gender) ,
                                            middleInitial: getMiddleInitial(ClientRelationshipGroupPartyPrimaryMember.personMiddleNameProperCased),
                                            age: ClientRelationshipGroupPartyPrimaryMember.birthDate ? calculateAgeFromBirthdate(moment(ClientRelationshipGroupPartyPrimaryMember.birthDate).format('MM/DD/YYYY')) : 0
                                        }

                        if(clientRelationshipGroupInformation.parties[1])
                        {
                            let ClientRelationshipGroupPartySecondaryMember:ClientRelationshipGroupParty = clientRelationshipGroupInformation.parties[1];
                            primaryContactForSecondary = {
                                ...primaryContactForSecondary,
                                firstName: ClientRelationshipGroupPartySecondaryMember.personFirstNameProperCased || "",
                                lastName: ClientRelationshipGroupPartySecondaryMember.personLastNameProperCased || "",
                                birthdate: ClientRelationshipGroupPartySecondaryMember.birthDate ? moment(ClientRelationshipGroupPartySecondaryMember.birthDate).format('YYYY-MM-DD') : calculateBirthdateFromAge(0),
                                gender: checkGender(ClientRelationshipGroupPartySecondaryMember.gender),
                                middleInitial: getMiddleInitial(ClientRelationshipGroupPartySecondaryMember.personMiddleNameProperCased),
                                age: ClientRelationshipGroupPartySecondaryMember.birthDate ? calculateAgeFromBirthdate(moment(ClientRelationshipGroupPartySecondaryMember.birthDate).format('MM/DD/YYYY')) : 0
                            }
                        }

                    }
                }
                dispatch(setProfileRequestForm({
                    ...profileRequestFormForPrimary,
                    primaryContact: {
                        ...primaryContact,
                        personalPlanningHorizon: data.defaultPersonalPlanningHorizon
                    },
                    effectiveTaxRate: taxRateWithDefaults(profileRequestFormForPrimary.effectiveTaxRate, data.taxRates),
                    managementFees: data.managementFees.managementFeePercentDefault,
                    accreditedStatus: data.accreditedStatus.defaultValue,
                    allocationType: data.allocationType.defaultValue,
                    alignmentStrategy: profileRequestFormForPrimary.alignmentStrategy || "Accumulation"
                }));
                dispatch(setProfileRequestFormDataForSecondary({
                    ...profileRequestFormDataForSecondary!,
                    primaryContact: {
                        ...primaryContactForSecondary!,
                        personalPlanningHorizon: data.defaultPersonalPlanningHorizon
                    },
                    effectiveTaxRate: taxRateWithDefaults(profileRequestFormForPrimary.effectiveTaxRate, data.taxRates),
                    managementFees: data.managementFees.managementFeePercentDefault,
                    accreditedStatus: data.accreditedStatus.defaultValue,
                    allocationType: data.allocationType.defaultValue,
                }));
                setSelectedPrimaryContact(clientRelationshipGroupInformation.parties[0]?.wmFullLegalEntityName!);
            } catch (error) {
                console.error('Could not fetch reference data', error);
            }
        };

        fetchReferenceData();
    }, []);


    const handlePrimaryContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedName = e.target.value;
        setSelectedPrimaryContact(selectedName);

        const nextPrimary = profileRequestFormDataForSecondary;
        const nextSecondary = profileRequestFormForPrimary;

        dispatch(setProfileRequestForm({...nextPrimary!,displayName : profileRequestFormForPrimary.displayName}));
        dispatch(setProfileRequestFormDataForSecondary({...nextSecondary}));
    };

    const checkFormIsValid = () => {
        const profileValidationForPrimary: NewClientProfileValidationContainer = validateProfileResponseContainer(profileRequestFormForPrimary, "Preferred Name");
        const profileValidationForSecondary: NewClientProfileValidationContainer = hasSecondaryClientRelationshipGroupMember
            ? validateProfileResponseContainer(profileRequestFormDataForSecondary!, "Preferred Name", false)
            : {newClientProfileForm: null, newClientProfileFormForSecondary: null};
        dispatch(setNewClientFormValidation({
            newClientProfileForm: profileValidationForPrimary.newClientProfileForm
        }));
        dispatch(setNewClientFormValidationForSecondary({
            newClientProfileForm: null,
            newClientProfileFormForSecondary: profileValidationForSecondary.newClientProfileFormForSecondary
        }));
        const isValidForPrimary = Object.values({...profileValidationForPrimary.newClientProfileForm!, age: null}).every(x => x === null);
        const isValidForSecondary = hasSecondaryClientRelationshipGroupMember ? Object.values({
            ...profileValidationForSecondary.newClientProfileFormForSecondary!,
            displayName: null,
            age: null
        }).every(x => x === null) : true;

        if (isValidForPrimary === true && isValidForSecondary === true && selectedRelationshipType != null) {
            dispatch(setIsValidForm(true));
            return true;
        } else {
            dispatch(setIsValidForm(false));
            return false;
        }
    }

    const handleSaveButton = async () => {
        if (checkFormIsValid()) {
            const includeSecondaryContact = Boolean(profileRequestFormDataForSecondary?.primaryContact?.firstName?.trim());
            const profileRequest: ProfileRequest = {
                ...profileRequestFormForPrimary,
                ...(includeSecondaryContact
                    ? {secondaryContact: profileRequestFormDataForSecondary?.primaryContact}
                    : {secondaryContact: null}),
                clientRelationshipGroupInfo: {
                    clientRelationshipGroupId: clientRelationshipGroupInformation.crgid!,
                    name: clientRelationshipGroupInformation.name!,
                    activeFlag: clientRelationshipGroupInformation.activeFlag === "Y",
                    relationShipType: selectedRelationshipType || ""
                },
                prospect: false,
                sample: false,
                resourceCode: clientRelationshipGroupInfoState.ulek!
            };
            try {
                const profileResponse = await clientManagementApiClient.postProfile(profileRequest);
                history.push({
                    pathname: `/Profile/${profileResponse.id}/ClientProfile/FamilyTree`
                });
            } catch (error: any) {
                console.error('Could not create profile', error?.message ?? error);
            }
        }
        else
        {
            dispatch(setIsSaveButtonClicked(true))
        }
    };

    const generalSettings = <Grid>
        <Row>
            <Col>
                <div className="h4">Profile Details</div>
                <hr className="section"/>
                <div className="parent">
                    <label className="planning-group-label">Client Relationship Group</label>
                    <div className="detail input-wrapper input-inline-align--right planning-group-name">
                        {clientRelationshipGroupInformation.name}
                    </div>
                </div>
                <div className="parent">
                    <Name name={profileRequestFormForPrimary.displayName}
                          label={"Display Name"}
                          onChange={(e: any) => dispatch(setProfileRequestForm({
                              ...profileRequestFormForPrimary,
                              displayName: e.target.value && validateInputRemovingSpaces(e.target.value)
                          }))}
                          required={true}
                          error={newClientProfileForm?.displayName}
                          forceShowErrors={isSaveButtonClicked}
                        />
                </div>
                <div className="planning-group-relation">
                    <label className="planning-group-label-relation">
                        Relationship Of Members <i className="color-text--error">*</i>
                    </label>
                    <div className="planning-group-relation-type">
                        <Dropdown
                        name="relationshipType"
                        aria-label="relationship-type"
                        className="relationship-type"
                        id="relationship_type_dropdown"
                        panelWidth="100%"
                        defaultText="Select..."
                        value={selectedRelationshipType}
                        error={isSaveButtonClicked && selectedRelationshipType === null
                            ? 'Relationship Type is required.'
                            : ''
                        }
                        onChange={(option: any) => setSelectedRelationshipType(option?.value || null)}
                    >
                        {getDisplayPartnerRelationshipTypesForClientRelationshipGroup().map(_type => {
                            return <DropdownItem key={_type} itemText={_type} value={_type}/>
                        })}
                    </Dropdown>
                    </div>
                </div>
                <div className="planning-group-primary-contact">
                    <label className="planning-group-label-contact">
                        Primary Contact
                    </label>
                    <div className="pg-primary-contact-radio-button">
                        <RadioGroup
                            name=""
                            className="primarycontact"
                            id="primarycontact"
                            aria-label="primarycontact"
                            aria-labelledby="primarycontact-label"
                            disabled={false}
                            onChange={handlePrimaryContactChange}
                            selected={selectedPrimaryContact}
                            values={primaryContactValues}
                        />
                    </div>
                </div>
                
                <NewClientPrimaryContact referenceData={referenceData} isFromOne={false} showDataForClientRelationshipGroup={true}/>
                {hasSecondaryClientRelationshipGroupMember && <NewClientPrimaryContact referenceData={referenceData} isFromOne={false} isPrimaryMember={false} showDataForClientRelationshipGroup={true}/>}
            </Col>
            <Col>
                <EffectiveTaxRates taxRate={profileRequestFormForPrimary.effectiveTaxRate}
                                   updateTaxRate={(taxRate) => {
                                       dispatch(setProfileRequestForm({
                                           ...profileRequestFormForPrimary,
                                           effectiveTaxRate: taxRate
                                       }))
                                   }}
                                   referenceData={referenceData}/>
                <NewClientFinancialModel referenceData={referenceData}
                                         financialModel={{
                                             accreditedStatus: referenceData.accreditedStatus.defaultValue,
                                             allocationType: referenceData.allocationType.defaultValue,
                                             alignmentStrategy: "Accumulation"
                                         }}
                                         updateFinancialModel={(financialModel) => {
                                             dispatch(setProfileRequestForm({
                                                 ...profileRequestFormForPrimary,
                                                 accreditedStatus: financialModel.accreditedStatus,
                                                 allocationType: financialModel.allocationType
                                             }))
                                         }
                                         }
                />
                <EffectiveFees managementFees={profileRequestFormForPrimary.managementFees}
                               updateManagementFees={(managementFees) => {
                                   dispatch(setProfileRequestForm({
                                       ...profileRequestFormForPrimary,
                                       managementFees: managementFees
                                   }))
                               }}
                               referenceData={referenceData}/>
            </Col>
        </Row>
    </Grid>;

    return (
            <div className="new-client-profile-page">
                <div className="client-table">
                    <Grid>
                        <Row>
                            <Col>
                            <span
                                className="font-xxl font-xxl">{`New Client Profile`}</span>
                                <p className="font-default color-text--error noMargin">* Required fields</p>
                            </Col>
                            <Col>
                                <div className="textalign-right">
                                    <Button className="marginright-md"
                                            icon="none"
                                            id="cancel_new_client_profile_button"
                                            includeRef={false}
                                            kind="secondary"
                                            onClick={() => {
                                                history.goBack();
                                            }}
                                            size="medium"
                                            tabIndex={0}
                                            type="button"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        icon="none"
                                        id="save_new_client_profile_button"
                                        includeRef={false}
                                        kind="primary"
                                        onClick={handleSaveButton}
                                        size="medium"
                                        tabIndex={0}
                                        type="button"
                                        disabled={false}
                                    >
                                        SAVE PROFILE
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                    <ProfileSettingsContent
                        showServiceTeamTab={false}
                        generalSettings={generalSettings}/>
                </div>
            </div>
    );
};

export default ClientRelationshipGroupInfo